<template>
  <div class="aplication">

    <template v-if="!$store.state.loading">

      <template v-if="!$store.state.user.cadastrar_senha">

        <div v-if="(($store.state.user.tipo <= 3 || $store.state.user.tipo == 9) && $store.state.config.instituicao.id) || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8) || $store.state.user.tipo == 10">
            <div class="tarja-header">
              <div class="logo" :style="{'width': ((collapsed || isMobile) ? '64px' : '240px') }">
                <router-link to="/">
                  <div v-if="!collapsed && !isMobile" style="display: flex; padding: 5px 15px;">
                    <img src="../assets/img/logo-white.png" alt="logo" class="logo-desktop">
                  </div>
                  <div v-if="collapsed || isMobile">
                    <img src="../assets/img/logo-mini.png" alt="logo" class="logo-mobile">
                  </div>
                </router-link>

                <router-link v-if="collapsed || isMobile" to="/">
                </router-link>
              </div>
              <div>
                <div class="btn-hidden-menu" @click="(isMobile) ? (btnHiddenMenu = !btnHiddenMenu) : (btnCollapsed = !btnCollapsed)">
                  <i class="fa fa-bars"></i>
                </div>
                  <div class="tarja-header-instituicao" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9">
                    <span> {{ $store.state.config.instituicao.nome }} </span>
                  </div>
                <ul class="menu-tarja-right">
                  <li class="imagem-avatar">
                    <div class="item">
                      <el-dropdown trigger="click" @command="clickSubMenu">
                        <span class="el-dropdown-link">
                          <span class="avatar">
                            <img v-if="!$store.state.user.imagem" src="@/assets/img/perfil.jpg">
                          </span>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="menu-sign">
                          <el-dropdown-item>
                            <i class="fa fa-user-circle"></i><span>{{ $store.state.user.name }}</span>
                          </el-dropdown-item>
                          <el-dropdown-item command="update-instituicao" divided v-if="($store.state.user.tipo <= 3 || $store.state.user.tipo == 9) && $store.state.user.instituicoes.length > 1">
                            <i class="fas fa-home"></i><span>Trocar Instituição</span>
                          </el-dropdown-item>
                          <el-dropdown-item command="logout" divided>
                            <i class="fa fa-sign-out-alt"></i><span>Sair</span>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div id="collapsed" :class="{'collapsed' : collapsed}">
              <sidebar-menu :menu="collapsed ? menuCompact : menuDefault" :btnCollapsed="btnCollapsed" :collapsed="collapsed" :isMobile="isMobile" :btnHiddenMenu="btnHiddenMenu" @collapse="onCollapse" @mobile="onMobile"/>
              <div class="sub-tarja-header">
                <h1>{{ $route.meta.title }}</h1>
                <el-breadcrumb style="margin-top: 5px;" separator="/">
                  <el-breadcrumb-item v-for="item in $route.meta.breadcrumb" :key="item.name" :to="{ path: item.url }">{{ item.txt }}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              <router-view/>
            </div>
        </div>

        <div class="container-select-instituicao" v-if="($store.state.user.tipo <= 2 || $store.state.user.tipo == 9) && !$store.state.config.instituicao.id">
              <c-panel class="c-panel-instituicao">
                  <h2 class="title-login">
                      <i class="far fa-user"></i>
                      Selecionar Instituição
                  </h2>
                  <el-form @submit.native.prevent="onSubmitSelectInstituicao" :model="config" ref="config" label-position="top">
                      <el-row :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24">
                              <el-form-item prop="instituicaoSelected" :rules="[$requiredChange]" key="instituicaoSelected">
                                  <el-select v-model="config.instituicaoSelected" filterable>
                                      <el-option v-for="(item, i) in $store.state.user.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                  </el-select>
                              </el-form-item>
                          </el-col>
                      </el-row>
                      <el-row :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24" class="u-text-right u-mt-20">
                              <el-button class="btn-go-in" native-type="submit">ENTRAR</el-button>
                          </el-col>
                      </el-row>
                  </el-form>
              </c-panel>
        </div>

      </template>

      <template v-else>

        <div class="container-select-instituicao">
          <c-panel class="c-panel-instituicao">
              <h2 class="title-login">
                  <i class="far fa-user"></i>
                  Cadastrar uma nova Senha
              </h2>
              <el-form @submit.native.prevent="onSubmitNovaSenha" :model="formNovaSenha" ref="formNovaSenha" label-position="top">
                  <el-row :gutter="10">
                      <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Senha" prop="password" :rules="[$requiredBlur]" key="password">
                            <el-input class="text-transform-none" v-model="formNovaSenha.password" maxlength="191" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Confirma Senha" prop="password_confirmation" :rules="[$requiredBlur]" key="password_confirmation">
                            <el-input class="text-transform-none" v-model="formNovaSenha.password_confirmation" maxlength="191" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                      <el-col :xs="24" :sm="24" :md="24" class="u-text-right u-mt-20">
                          <el-button type="primary" native-type="submit">CADASTRAR SENHA</el-button>
                      </el-col>
                  </el-row>
              </el-form>
          </c-panel>
        </div>

      </template>

    </template>

    <div v-if="$store.state.loading" class="loading-layout"></div>

    <el-dialog append-to-body title="DOCUMENTO" :close-on-click-modal="false" :visible.sync="dialogPrint" width="80%" top="5vh" class="ss-header-dialog-print">
        <div v-if="dialogPrint">

          <div v-if="loadingPdf">
            <p class="u-text-center">
              ATENÇÃO: O processo de geração de PDF pode demorar vários minutos para ser renderizado dependendo da quantidade de
              registros no relatório.
            </p>
            <div style="text-align: center; margin: 50px 0px;">
              <img src="/public/img/loading-bar.gif" />
            </div>
          </div>
          <div class="u-text-center" style="color: #ff0000; margin: 50px 0px;" v-if="loadingPdfErro">
            Ops! Algo de errado aconteceu ao gerar o relatório. Por favor, entre em contato com o setor de legalização da Instituição.
          </div>
          <iframe ref="myDiv"  id="iframe" scrolling="no" style="width: 100%; height: 130vh; border: none;" src="" >
            <p>Relatório indisponível! Seu navegador não é compatível.</p>
          </iframe>
        </div>
    </el-dialog>

    <el-dialog class="ss-loading" top="0" width="200px" :visible.sync="loading" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>
        <div style="text-align: center;">
          <img src="/public/img/loading.gif" />
        </div>
    </el-dialog>

  </div>
</template>
<script>

import SidebarMenu from './menu/SidebarMenu.vue'

export default {
  name: "index",
  data: () => ({
    loadingPdfErro: false,
    loadingPdf: false,
    valid: [],
    dialogValid: false,
    config: {
      instituicaoSelected: ''
    },
    btnHiddenMenu: true,
    dialogPrint: false,
    loading: null,
    menuDefault: [

      { header: true, title: 'Menu', tipoUser: [2] },
      { href: '/admin/diario/frequencia', title: 'Frequência', icon: 'far fa-id-card', tipoUser: [2] },
      { href: '/admin/diario/notas', title: 'Notas', icon: 'fas fa-clipboard-list', tipoUser: [2] },
      { href: '/admin/diario/conteudo', title: 'Conteúdo', icon: 'fas fa-sitemap', tipoUser: [2] },

      { header: true, title: 'Matrículas', tipoUser: [0, 4, 6, 9, 10] },
      { href: '/admin/aluno', title: 'Alunos', icon: 'fas fa-user-graduate', tipoUser: [0, 4, 6, 9, 10] },

      {
        title: 'Pré-matrícula', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
        [
          { href: '/admin/agenda', title: 'Agenda', icon: 'fa fa-list-alt'},
          { href: '/admin/pre-matricula-inscritos', title: 'Inscritos 2º Fase', icon: 'fa fa-list-alt' },
          { href: '/admin/pre-matricula-inscritos-novatos', title: 'Inscritos', icon: 'fa fa-list-alt' }
        ]
      },
      {
        title: 'Pré-matrícula', icon: 'fa fa-sitemap', tipoUser: [0, 1], child:
        [
          { href: '/admin/agenda', title: 'Agenda', icon: 'fa fa-list-alt', tipoUser: [0, 1] },
          { href: '/admin/pre-matricula-inscritos-novatos', title: 'Inscritos', icon: 'fa fa-list-alt', tipoUser: [0, 1, 4, 6] }
        ]
      },
      { href: '/admin/autorizacao', title: 'Autorizações Instituição', icon: 'fas fa-user-graduate', tipoUser: [4, 6] },
      { href: '/admin/vagas', title: 'Vagas do Município', icon: 'fas fa-chalkboard-teacher', tipoUser: [4, 6] },
      { href: '/admin/matriculas-tempo-real', title: 'Matrículas Tempo Real', icon: 'fas fa-history', tipoUser: [0, 1, 4, 6, 9, 10] },


      { header: true, title: 'Instituição', tipoUser: [0, 1, 4, 6, 9, 10] },

      {
        title: 'Educacenso', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
        [
          { href: '/admin/educacenso', title: 'Educacenso 2025', icon: 'fa fa-list-alt' },
          { href: '/admin/alteracao-nome', title: 'Alteração de Nome', icon: 'far fa-copy' },
        ]
      },  

      { href: '/admin/educacenso', title: 'Educacenso 2025', icon: 'fas fa-align-left', tipoUser: [0] },

      { href: '/admin/instituicao/index', title: 'Instituição', icon: 'fas fa-home', tipoUser: [0, 4, 6, 9, 10] },
      { href: '/admin/curso', title: 'Cursos', icon: 'fas fa-align-left', tipoUser: [4, 6] },
      // { href: '/admin/turma', title: 'Turmas', icon: 'fas fa-door-closed', tipoUser: [9, 10] },
      
      // {
      //   title: 'Turmas', icon: 'fa fa-sitemap', tipoUser: [0, 1, 5], child:
      //   [
      //     { href: '/admin/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
      //     { href: '/admin/turma/situacao-academica', title: 'Situação Acadêmica', icon: 'far fa-copy' },
      //   ]
      // },
      
      { href: '/admin/turma', title: 'Turmas', icon: 'fas fa-door-closed', tipoUser: [0, 1, 9, 10] },

      {
        title: 'Turmas', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
        [
          { href: '/admin/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          { href: '/admin/turma/projecao', title: 'Projeção', icon: 'fa fa-list-alt' },
        ]
      },
      { href: '/admin/servidor', title: 'Servidor', icon: 'fas fa-user-tie', tipoUser: [0, 4, 6, 9, 10] },

      { header: true, title: 'Sistema', tipoUser: [0, 4, 6, 9, 10] },
      {
        title: 'Relatórios', icon: 'fa fa-sitemap', tipoUser: [0, 1, 4, 6, 9, 10], child:
        [
          { href: '/admin/relatorio/aluno', title: 'Alunos', icon: 'fa fa-list-alt' },
          { href: '/admin/relatorio/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
          // { href: '/admin/relatorio/relatorio-inscritos', title: 'Pré-Matrícula', icon: 'fa fa-list-alt' },
          { href: '#', title: 'Req. Matrícula em Branco', icon: 'fa fa-list-alt', click: 'req-matricula' }
        ]
      },
      { href: '/admin/usuario', title: 'Usuário', icon: 'far fa-user-circle', tipoUser: [4, 6] },
      // { href: '/admin/suporte', title: 'Suporte', icon: 'fas fa-clipboard-list', tipoUser: [0, 4, 6, 9] },
      { href: '/admin/log', title: 'Logs', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 4, 6, 9] },
      { href: '/admin/log-pre-matricula', title: 'Logs Pré-matrícula', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 4, 6] },
      // { href: '#', title: 'Suporte', icon: 'fas fa-clipboard-list', tipoUser: [0, 4, 6] },
      { href: '/admin/ajuda', title: 'Ajuda', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 4, 6, 9] },
      { href: '/admin/calculadora', title: 'Calculadora de Idade', icon: 'fas fa-calculator', tipoUser: [0, 1, 4, 6] },
      
      { href: '/admin/sistema', title: 'Período Letivo', icon: 'fas fa-cogs', tipoUser: [4] },
      {
        title: 'Cadastros Gerais', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
        [
          { href: '/admin/endereco', title: 'Endereço', icon: 'fa fa-list-alt' },
          { href: '/admin/dados-medicos', title: 'Dados Médicos', icon: 'fa fa-list-alt' },
          { href: '/admin/disciplina', title: 'Disciplinas', icon: 'fa fa-list-alt' },
          { href: '/admin/instituicao-superior', title: 'Inst. Nível Superior', icon: 'fa fa-list-alt' },
          { href: '/admin/curso-superior', title: 'Cursos N. Superior', icon: 'fa fa-list-alt' },
          { href: '/admin/curso-complementar', title: 'Cursos Complementar', icon: 'fa fa-list-alt' },
          { href: '/admin/atividade-complementar', title: 'Ativid. Complementar', icon: 'fa fa-list-alt' },
          { href: '/admin/alergia', title: 'Alergias', icon: 'fa fa-list-alt' },
          { href: '/admin/deficiencia', title: 'Deficiências', icon: 'fa fa-list-alt' },
          { href: '/admin/doenca', title: 'Doenças', icon: 'fa fa-list-alt' }
        ]
      },
    ],
    collapsed: false,    
    menuCompact: [
      {
        header: true, 
        title: 'Menu',
        icon: 'fas fa-file',
        tipoUser: [2],
        items: [
            { href: '/admin/diario/frequencia', title: 'Frequência', icon: 'fas fa-id-card', tipoUser: [2] },
            { href: '/admin/diario/notas', title: 'Notas', icon: 'fas fa-clipboard-list', tipoUser: [2] },
            { href: '/admin/diario/conteudo', title: 'Conteúdo', icon: 'fas fa-sitemap', tipoUser: [2] },
        ]
      },
      {
        header: true,
        title: 'Matrículas',
        icon: 'fas fa-graduation-cap',
        tipoUser: [0, 4, 6, 9, 10],
        items: [
            { href: '/admin/aluno', title: 'Alunos', icon: 'fas fa-user-graduate', tipoUser: [0, 4, 6, 9, 10] },
            {
              title: 'Pré-matrícula', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
              [
                { href: '/admin/agenda', title: 'Agenda', icon: 'fa fa-list-alt'},
                { href: '/admin/pre-matricula-inscritos', title: 'Inscritos 2º Fase', icon: 'fa fa-list-alt' },
                { href: '/admin/pre-matricula-inscritos-novatos', title: 'Inscritos', icon: 'fa fa-list-alt' }
              ]
            },
            {
              title: 'Pré-matrícula', icon: 'fa fa-sitemap', tipoUser: [0, 1], child:
              [
                { href: '/admin/agenda', title: 'Agenda', icon: 'fa fa-list-alt', tipoUser: [0, 1] },
                { href: '/admin/pre-matricula-inscritos-novatos', title: 'Inscritos', icon: 'fa fa-list-alt', tipoUser: [0, 1, 4, 6] }
              ]
            },
            { href: '/admin/autorizacao', title: 'Autorizações Instituição', icon: 'fas fa-user-graduate', tipoUser: [4, 6] },
            { href: '/admin/vagas', title: 'Vagas do Município', icon: 'fas fa-chalkboard-teacher', tipoUser: [4, 6] },
            { href: '/admin/matriculas-tempo-real', title: 'Matrículas Tempo Real', icon: 'fas fa-history', tipoUser: [0, 1, 4, 6, 9, 10] },
        ]
      },
      {
        header: true,
        title: 'Instituição',
        icon: 'fas fa-school',
        tipoUser: [0, 1, 4, 6, 9, 10],
        items: [
            {
            title: 'Educacenso', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
              [
                { href: '/admin/educacenso', title: 'Educacenso 2025', icon: 'fa fa-list-alt' },
                { href: '/admin/alteracao-nome', title: 'Alteração de Nome', icon: 'far fa-copy' },
              ]
            },  

            { href: '/admin/educacenso', title: 'Educacenso 2025', icon: 'fas fa-align-left', tipoUser: [0] },

            { href: '/admin/instituicao/index', title: 'Instituição', icon: 'fas fa-home', tipoUser: [0, 4, 6, 9, 10] },
            { href: '/admin/curso', title: 'Cursos', icon: 'fas fa-align-left', tipoUser: [4, 6] },
            // { href: '/admin/turma', title: 'Turmas', icon: 'fas fa-door-closed', tipoUser: [9, 10] },
            
            // {
            //   title: 'Turmas', icon: 'fa fa-sitemap', tipoUser: [0, 1, 5], child:
            //   [
            //     { href: '/admin/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
            //     { href: '/admin/turma/situacao-academica', title: 'Situação Acadêmica', icon: 'far fa-copy' },
            //   ]
            // },
            
            { href: '/admin/turma', title: 'Turmas', icon: 'fas fa-door-closed', tipoUser: [0, 1, 9, 10] },

            {
              title: 'Turmas', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
              [
                { href: '/admin/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
                { href: '/admin/turma/projecao', title: 'Projeção', icon: 'fa fa-list-alt' },
              ]
            },
            { href: '/admin/servidor', title: 'Servidor', icon: 'fas fa-user-tie', tipoUser: [0, 4, 6, 9, 10] },
        ]
      },
      {
        header: true,
        title: 'Sistema',
        icon: 'fas fa-sitemap',
        tipoUser: [0, 4, 6, 9, 10],
        items: [
            {
            title: 'Relatórios', icon: 'fa fa-sitemap', tipoUser: [0, 1, 4, 6, 9, 10], child:
              [
                { href: '/admin/relatorio/aluno', title: 'Alunos', icon: 'fa fa-list-alt' },
                { href: '/admin/relatorio/turma', title: 'Turmas', icon: 'fa fa-list-alt' },
                // { href: '/admin/relatorio/relatorio-inscritos', title: 'Pré-Matrícula', icon: 'fa fa-list-alt' },
                { href: '#', title: 'Req. Matrícula em Branco', icon: 'fa fa-list-alt', click: 'req-matricula' }
              ]
            },
            { href: '/admin/usuario', title: 'Usuário', icon: 'far fa-user-circle', tipoUser: [4, 6] },
            // { href: '/admin/suporte', title: 'Suporte', icon: 'fas fa-clipboard-list', tipoUser: [0, 4, 6, 9] },
            { href: '/admin/log', title: 'Logs', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 4, 6, 9] },
            { href: '/admin/log-pre-matricula', title: 'Logs Pré-matrícula', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 4, 6] },
            // { href: '#', title: 'Suporte', icon: 'fas fa-clipboard-list', tipoUser: [0, 4, 6] },
            { href: '/admin/ajuda', title: 'Ajuda', icon: 'fas fa-clipboard-list', tipoUser: [0, 1, 4, 6, 9] },
            { href: '/admin/calculadora', title: 'Calculadora de Idade', icon: 'fas fa-calculator', tipoUser: [0, 1, 4, 6] },
            
            { href: '/admin/sistema', title: 'Período Letivo', icon: 'fas fa-cogs', tipoUser: [4] },
            {
              title: 'Cadastros Gerais', icon: 'fa fa-sitemap', tipoUser: [4, 6], child:
              [
                { href: '/admin/endereco', title: 'Endereço', icon: 'fa fa-list-alt' },
                { href: '/admin/dados-medicos', title: 'Dados Médicos', icon: 'fa fa-list-alt' },
                { href: '/admin/disciplina', title: 'Disciplinas', icon: 'fa fa-list-alt' },
                { href: '/admin/instituicao-superior', title: 'Inst. Nível Superior', icon: 'fa fa-list-alt' },
                { href: '/admin/curso-superior', title: 'Cursos N. Superior', icon: 'fa fa-list-alt' },
                { href: '/admin/curso-complementar', title: 'Cursos Complementar', icon: 'fa fa-list-alt' },
                { href: '/admin/atividade-complementar', title: 'Ativid. Complementar', icon: 'fa fa-list-alt' },
                { href: '/admin/alergia', title: 'Alergias', icon: 'fa fa-list-alt' },
                { href: '/admin/deficiencia', title: 'Deficiências', icon: 'fa fa-list-alt' },
                { href: '/admin/doenca', title: 'Doenças', icon: 'fa fa-list-alt' }
              ]
            },
        ]
      }
    ],
    btnCollapsed: false,
    isMobile: false,
    formNovaSenha:{
      password: '',
      password_confirmation: '',
      cadastrar_senha: false
    }
  }),
  async mounted(){

    if(!sessionStorage.getItem("ed543672Token")){
      this.$store.commit('logout');
      return;
    }

    this.$store.dispatch('getUser');
  },
  methods: {
    onSubmitNovaSenha(){

      this.$refs.formNovaSenha.validate((valid) =>{ if(valid){

        window.eventBus.$emit('loading', true);

        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/usuario/update/${this.$store.state.user.id}`, this.formNovaSenha, this.$store.getters.getHeaderAuth).then(response => {

            if(typeof response.data.throw !== 'undefined'){

              window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});
              window.eventBus.$emit('loading', false);

            }else{

              window.eventBus.$emit('loading', false);
              window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

              this.$store.dispatch('getUser');
            }

        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });


      }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});


    },
    onCollapse(val) {
      this.collapsed = val
    },
    onMobile(val) {
      this.isMobile = val
    },
    clickSubMenu(clicado){

      if(clicado){

        if(clicado == 'logout'){

          this.logout();

        }else if(clicado == 'update-instituicao'){

          this.$store.commit('setInstituicao', false);

        }else if(clicado == 'perfil'){

          this.$router.push('/admin/perfil');

        }
      }

    },
    onSubmitSelectInstituicao() {

      this.$refs.config.validate((valid) =>{ if(valid){

        for(let i in this.$store.state.user.instituicoes){

          if(this.$store.state.user.instituicoes[i].id == this.config.instituicaoSelected){

            this.$store.commit('setInstituicao', this.$store.state.user.instituicoes[i]);
          }

        }

      }});

    },
    logout(){

      this.$store.commit('logout');
    }
  },
  created: function(){

      window.eventBus.$on('alert', data =>  {

          let time = 3000;

          if(data.type == 'error' || data.type == 'warning')
            time = 6000;

          this.$message({
            message: data.msg,
            type: data.type,
            duration: time
          });

      });

      window.eventBus.$on('loading', data =>  {

          this.loading = data;
      });

      window.eventBus.$on('print', data =>  {

          this.dialogPrint = true;
          this.loadingPdfErro = false;
          this.loadingPdf = true;
          let instance = this;

          setTimeout(()=>{

            let iframe = this.$refs.myDiv
            let url = this.$store.state.config.baseUrlApi + data.url;

            var param = new FormData();
            param.append("param", JSON.stringify(data.param));

            let headers = [['Authorization', 'Bearer ' + sessionStorage.getItem("ed543672Token")]];

            var xhr = new XMLHttpRequest();

            xhr.open('POST', url, true);
            xhr.onreadystatechange = handler;
            xhr.responseType = 'blob';
            headers.forEach(function(header) {
              xhr.setRequestHeader(header[0], header[1]);
            });
            xhr.send(param);

            function handler() {
              if (this.readyState === this.DONE) {
                if (this.status === 200) {
                  iframe.src = URL.createObjectURL(this.response);
                  instance.loadingPdf = false;
                } else {
                  console.error('XHR failed', this);
                  instance.loadingPdf = false;
                  instance.loadingPdfErro = true;
                }
              }
            }

          }, 1000);
      });

      window.eventBus.$on('throw', data =>  {

          let alertas = '';

          for(let i in data){

            alertas += data[i].msg;

            if(i != data.length){

              alertas += '<br>';
            }

          }

          this.$alert(alertas, 'Atenção!', { dangerouslyUseHTMLString: true, confirmButtonText: 'OK' }).then(() => { }).catch(() => { });

          this.dialogValid = true;
          this.valid = data;
      });

  },
  components: {
    SidebarMenu
  }
};
</script>
<style type="text/css">
  .st0{fill:#FFFFFF;}
</style>